// import React, { useState } from 'react';
// import { connect } from "react-redux";
// import Swal from 'sweetalert2'
// import Button from '@mui/material/Button';
// import Box from '@mui/material/Box';
// import { Grid, FormControl, Select, MenuItem, theme } from '@mui/material';
// import DateTimePicker from '@mui/lab/DateTimePicker';
// import TextField from '@mui/material/TextField';
// import MainCard from 'ui-component/cards/MainCard';
// import DateAdapter from '@mui/lab/AdapterMoment';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';
// import DatePicker from '@mui/lab/DatePicker';
// import { Typography } from '@mui/material';
// import { gridSpacing } from 'store/constant';
// import moment from 'moment'

// import { useTheme } from '@mui/material/styles';

// // ===============================|| UI COLOR ||=============================== //

// const UIColor = ({ auth }) => {


//     let User = auth?.User;
//     const theme = useTheme();
//     var days = 4749;
//     var newdate = new Date(Date.now() - days * 24 * 60 * 60 * 1000)
//     const d = new Date(newdate);
//     const formatdate = moment(d).format('YYYY-MM-DD');


//     const [name, Setname] = useState(User.name);
//     const [dob, Setdob] = useState(User.dob);
//     const [gender, Setgender] = useState(User.gender);
//     const [religion, Setreligion] = useState(User.religion)



//     return (

//         <Grid container direction="column" justifyContent="flex-end"  backgroundColor={{ backgroundColor: 'red' }}>
//             <Grid item xs={12}>
//                 <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
//                     <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
//                         <Typography style={{ color: 'red' }}><h1>My Hussain</h1></Typography>
//                         <div style={{ margin: 20 }}>
//                             <Typography >Your Name</Typography>
//                             <TextField

//                                 id="standard-start-adornment"
//                                 sx={{ m: 1, width: '50ch' }}
//                                 onChange={(event) => Setname(event.target.value)}
//                                 type={'text'}
//                                 value={name}
//                                 color="error"
//                             />
//                         </div>

//                         <div style={{ margin: 20 }}>
//                             <Typography >Date of birth</Typography>
//                             <LocalizationProvider dateAdapter={DateAdapter}>
//                                 <DatePicker
//                                     maxDate={moment(formatdate)}
//                                     value={dob}
//                                     onChange={(newValue) => {
//                                         Setdob(newValue);
//                                     }}
//                                     renderInput={(params) => <TextField disabled={true}  {...params} color="error"
//                                         sx={{ m: 1, width: '50ch' }} style={{ marginTop: 10 }} />}
//                                     style={{ border: 0 }}
//                                 />
//                             </LocalizationProvider>
//                         </div>

//                         <div style={{ margin: 20 }}>
//                             <Typography >Gender</Typography>
//                             <FormControl>
//                                 <Select
//                                     value={gender}
//                                     sx={{ m: 1, width: '50ch' }}
//                                     onChange={(e) => Setgender(e.target.value)}>
//                                     <MenuItem value={"male"}>Male</MenuItem>
//                                     <MenuItem value={"female"}>Female</MenuItem>
//                                 </Select>
//                             </FormControl>
//                         </div>

//                         <div style={{ margin: 20 }}>
//                             <Typography >Religion</Typography>
//                             <FormControl>
//                                 <Select
//                                     value={religion}
//                                     sx={{ m: 1, width: '50ch' }}
//                                     onChange={(e) => Setreligion(e.target.value)}>
//                                     <MenuItem value={"Muslim"}>Muslim</MenuItem>
//                                     <MenuItem value={"Non-Muslim"}>Non-Muslim</MenuItem>
//                                 </Select>
//                             </FormControl>
//                         </div>

//                         <Button variant="outlined" color="error" onClick={() => alert('h')}
//                         >Continue & Confirm</Button>

//                     </Grid>
//                 </Grid>
//             </Grid>
//         </Grid>



//     )
// };

// export default UIColor;


import { Link } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, Grid, Stack, Typography, useMediaQuery } from '@mui/material';

// project imports
import AuthWrapper1 from './AuthWrapper1';
import AuthCardWrapper from './AuthCardWrapper';
import Logo from 'ui-component/Logo';
import AuthRegister from './RegisterUser';
import AuthFooter from 'ui-component/cards/AuthFooter';

// assets

// ===============================|| AUTH3 - REGISTER ||=============================== //

const Register = ({auth}) => {
    return (
        <AuthWrapper1>
            <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}>
                <Grid item xs={12}>
                    <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
                        <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
                            <AuthCardWrapper>
                                <Grid container spacing={2} alignItems="center" justifyContent="center">
                                    <Grid item xs={12}>
                                        <AuthRegister  auth={auth}/>
                                    </Grid>
                                    
                                </Grid>
                            </AuthCardWrapper>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
                    <AuthFooter />
                </Grid>
            </Grid>
        </AuthWrapper1>
    );
};

export default Register;



